import { Box, theme } from '@everlywell/ui-kit';
import React from 'react';
import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import ShapeCard from '../../ShapeCard';
import { InstaInspiredCarouselProps } from '../StoriesCarousel';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const InstaInspiredCarousel: React.FC<InstaInspiredCarouselProps | null> = (
  props,
) => {
  if (!props || !props.shapeCardsData) {
    return null;
  }

  const { shapeCardsData } = props;

  return (
    <Box
      data-testid="insta-inspired-carousel"
      sx={{
        '.swiper-pagination': {
          top: '0 !important',
          bottom: 'unset !important',
        },

        '.swiper-pagination-bullet': {
          width: '14vw',
          height: '5px',
          borderRadius: '5px',
          position: 'relative',
          overflow: 'hidden',

          '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: '0',
            right: '0',
            bottom: '0',
            left: '0',
          },
        },

        '.swiper-pagination-bullet-active': {
          background: theme.colors.tints.medGrey,

          '&::before': {
            backgroundColor: theme.colors.tints.white,
            animation:
              'slide-progress 5s cubic-bezier(0.3, 0, 0.3, 1) forwards',

            '.swiper-paused &': {
              animationPlayState: 'paused',
            },
          },
        },

        '@keyframes slide-progress': {
          '0%': {
            transform: 'translateX(-100%)',
          },

          '100%': {
            transform: 'translateX(0)',
          },
        },
        '.swiper-button-prev': {
          color: 'transparent',
        },
        '.swiper-button-next': {
          color: 'transparent',
        },
      }}
    >
      <Swiper
        modules={[EffectFade, Autoplay, Pagination, Navigation]}
        effect={'fade'}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        slidesPerView={1}
        pagination={{
          type: 'bullets',
          clickable: true,
        }}
        navigation={true}
        loop={true}
        watchSlidesProgress={true}
      >
        {shapeCardsData?.map((card, index) => (
          <SwiperSlide key={`shape-card-${index}`}>
            <ShapeCard cardVariant="vertical" {...card} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default InstaInspiredCarousel;
